export default __webpack_public_path__ + "static/media/splash.5aad95d0.png";